import api from './api';

export type ServiceSource = 'wechat' | 'meituan' | 'douyin';

export interface ServiceCategory {
  id: string;
  parentId: string;
  name: string;
  description?: string;
  icon: string;
  source: ServiceSource;
  sort: number;
  status: number;
  createdAt: string;
  updatedAt: string;
  children?: ServiceCategory[];
}

export interface CreateServiceCategoryRequest {
  parentId?: string;
  name: string;
  description?: string;
  icon?: string;
  source: ServiceSource;
  sort?: number;
  status?: number;
}

export interface UpdateServiceCategoryRequest {
  parentId?: string;
  name?: string;
  description?: string;
  icon?: string;
  source?: ServiceSource;
  sort?: number;
  status?: number;
}

export const serviceSourceOptions = [
  { label: '微信', value: 'wechat' as ServiceSource },
  { label: '美团', value: 'meituan' as ServiceSource },
  { label: '抖音', value: 'douyin' as ServiceSource },
];

export const serviceSourceMap = serviceSourceOptions.reduce<Record<string, string>>((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export const getServiceCategoryTree = () => api.get<ServiceCategory[]>('/service-categories');

export const getAllServiceCategories = () => api.get<ServiceCategory[]>('/service-categories/all');

export const getServiceCategory = (id: string) => api.get<ServiceCategory>(`/service-categories/${id}`);

export const createServiceCategory = (data: CreateServiceCategoryRequest) => api.post<ServiceCategory>('/service-categories', data);

export const updateServiceCategory = (id: string, data: UpdateServiceCategoryRequest) => api.put<ServiceCategory>(`/service-categories/${id}`, data);

export const deleteServiceCategory = (id: string) => api.delete(`/service-categories/${id}`);
